export const NEW_EMAIL = 'NEW_EMAIL';
